import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const FileSizeSettingSkeleton = memo(() => {
  return (
    <SettingCardSkeleton
      titleWidth={150}
      controls={["buttons", "buttons", "buttons"]}
    />
  );
});

FileSizeSettingSkeleton.displayName = "FileSizeSettingSkeleton";

export default FileSizeSettingSkeleton;
